import React from 'react'
import { Alert } from 'reactstrap'
import PropTypes from 'prop-types'

/**
 * View of the status of the restore operation
 * for UploadCSVBackups.
 * @param {object} props 
 */
function RestoreStatus({
  backup,
  processedStudents,
  restoreError,
  restoreStatus,
  totalStudents,
}) {
  if (!backup) return null

  const UA_STATUS = 'Processing student responses...'

  let status = restoreStatus
  if (restoreStatus === UA_STATUS && totalStudents) {
    status = `Processing student responses ( ${processedStudents} / 
              ${totalStudents} )...`
  } 

  return (
    <div>
      <Alert color='info'>{status}</Alert>
      {restoreError &&
        <Alert color='danger'>Error restoring.</Alert>
      }
    </div>
  )
}

const { bool, number, object, string, } = PropTypes
RestoreStatus.propTypes = {
  backup: object,
  processedStudents: number.isRequired,
  restoreError: bool.isRequired,
  restoreStatus: string.isRequired,
  totalStudents: number.isRequired,
}
export default RestoreStatus


// WEBPACK FOOTER //
// ./src/components/Assessment/UploadCSVComponents/RestoreStatus.js